// "Heat" ramp (ColorBrewer RdYlGn, reversed) — green/low density through yellow to
// red/high density. Shared between WallPreviewHeatmap (the canvas) and its legend, so the
// key always matches what's drawn.
export const HEATMAP_RAMP_HEX = [
  "#1a9850",
  "#91cf60",
  "#ffffbf",
  "#fc8d59",
  "#d73027",
];

const HEATMAP_RAMP_RGB = HEATMAP_RAMP_HEX.map(
  (hex) =>
    [
      parseInt(hex.slice(1, 3), 16),
      parseInt(hex.slice(3, 5), 16),
      parseInt(hex.slice(5, 7), 16),
    ] as const,
);

export function colorForDensity(
  density: number,
): readonly [number, number, number] {
  const clamped = Math.min(1, Math.max(0, density));
  const scaled = clamped * (HEATMAP_RAMP_RGB.length - 1);
  const index = Math.min(HEATMAP_RAMP_RGB.length - 2, Math.floor(scaled));
  const localT = scaled - index;
  const [r1, g1, b1] = HEATMAP_RAMP_RGB[index];
  const [r2, g2, b2] = HEATMAP_RAMP_RGB[index + 1];

  return [
    r1 + (r2 - r1) * localT,
    g1 + (g2 - g1) * localT,
    b1 + (b2 - b1) * localT,
  ];
}
